import { SpyneTrait } from "spyne";
import { UtilTraits } from "traits/util-traits";

export class StringCloneUtilsTraits extends SpyneTrait {
  constructor(context) {
    let traitPrefix = "stringClone$";

    super(context, traitPrefix);
  }

  static stringClone$HelloWorld() {
    return "Hello World";
  }

  static stringClone$StringIsEmpty(str = "") {
    return !str.match(/\S/);
  }

  static stringClone$CopyStr(str) {
    return str;
  }

  static stringClone$SplitByLines(str) {
    return String(str).split("\n");
  }

  static stringClone$JoinWLineBreaks(arr) {
    return arr.join("\n");
  }

  static stringClone$GetStartSpaceLength(str) {
    return UtilTraits.util$Exists(str) ? str.match(/^(\s+)(.*)$/)[1].length : 0;
  }

  static stringClone$ReplaceLines(origStr, insertArr = []) {
    const origStrArr = StringCloneUtilsTraits.stringClone$SplitByLines(origStr);

    const forEachInsert = (arr, i) => {
      const [str, lineNum, spaces] = arr;
      const spacesNum =
        spaces ||
        StringCloneUtilsTraits.stringClone$GetStartSpaceLength(
          origStrArr[lineNum],
        );

      //console.log("SPACES NUM ", {lineNum,spacesNum})
      const strReplace = String(" ").repeat(spacesNum).concat(str);
      origStrArr.splice(lineNum, 1, strReplace);
    };

    insertArr.forEach(forEachInsert);

    return StringCloneUtilsTraits.stringClone$JoinWLineBreaks(origStrArr);
  }
}
